// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_states} from './types';
import Chevron_left from '../../img/icons/24/chevron_left.svg';
import {is_valid_email} from 'zurl';
import {get_error_description} from './errors';
import {login_process} from './utils';
import hopt from 'hola_opt';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Lottie} from '../../../../hola/pub/lib/lottie';
import {Captcha} from '../../../../hola/pub/login/captcha';
import {Pass_meter} from './pass_meter';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Button} from '../../lib/button';
import {Checkbox} from '../../lib/checkbox';
import {Password_input, Text_input} from '../../../../shared/ui/input';

interface i_login_buttons_props {
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    signup_subscription: boolean;
    signup_bonus: boolean;
    qr_code: string;
    no_banner?: boolean;
    Banner?: JSX.Element;
    can_back: boolean;
    pro_signup?: boolean;
}

export const State_signup_with_email = (props: i_login_buttons_props)=>{
    const [email, set_email] = useState('');
    const {theme} = useContext(Settings_context);
    const [password, set_password] = useState('');
    const [save_two_step, set_save_two_step] = useState(true);
    const [process_state, set_process_state] = useState(login_process.state);
    const [error, set_error] = useState({
        fields: [],
        code: '',
    });
    useEffect(()=>{
        if (!password && login_process.last_process_error == 'wrong_password')
            return;
        set_error({fields: [], code: ''});
    }, [email, password]);
    useEffect(()=>{
        login_process.init_recaptcha();
        const uns_error_change = login_process.on('last_process_error_changed',
        ()=>{
            if (login_process.last_process_error == 'wrong_password')
                set_password('');
            if (login_process.last_process_error == 'recaptcha')
            {
                set_error({
                    fields: ['captcha'],
                    code: login_process.last_process_error,
                });
                return;
            }
            set_error({
                fields: login_process.last_process_error ?
                    ['email', 'password'] : [],
                code: login_process.last_process_error,
            });
        });
        const uns_state = login_process.on('state_changed', ()=>{
            set_process_state(login_process.state);
        });
        return ()=>{
            uns_error_change();
            uns_state();
        };
    }, []);
    const render_pass_meter = pass=>{
      return <div className={cn(styles.pass_meter)}>
        <Pass_meter pass={pass} email={email} bars/>
      </div>;
    };
    return <div className={cn(styles.form_content, styles.signup_with_email)}>
        <div className={cn(styles.lottie_overlay,
          process_state=='in_progress' && styles.lottie_visible)}>
          <Lottie src={oculus_img_url('animation/button_loader.json')}
            width="62px" height="30px" autoplay loop/>
        </div>
        <div className={styles.head}>
          {props.can_back && <button className={styles.back_btn} onClick={()=>{
            props.go_to('signup_buttons', -1);
          }}><Chevron_left/></button>}
          <p className={cn(theme.p20, theme.bold, theme.color_n700)}>
            <b>Sign up</b></p>
        </div>
        <form className={styles.login_form}>
          <Text_input
            label={'Email'}
            placeholder={'user@example.com'}
            on_change={set_email}
            value={email}
            is_error={error.fields.includes('email')}
            on_blur={value=>{
              if (!is_valid_email(value))
              {
                return set_error({fields: ['email'], code:
                  'invalid_email'});
              }
            }}
            input_props={{autoComplete: 'email'}}
          />
          <Password_input
            label={'Password'}
            placeholder={''}
            on_change={set_password} value={password}
            is_error={error.fields.includes('password')}
            error={error.code && !error.fields.includes('captcha') ?
              get_error_description(error.code, email, props.go_to,
                props.get_enc_url, true, false, styles.input_err) : ''}
            pass_meter={!error.code && render_pass_meter}
          />
          {hopt.mtcaptcha && hopt.mtcaptcha.enable && <Captcha
            error_style={error.fields.includes('captcha')}
            on_verified={()=>{
              set_error({fields: [], code: ''});
            }} error={error}/>}
          <div className={styles.message_checkbox_save_two}>
            <Checkbox caption={''} checked={save_two_step} size="s"
              on_change={set_save_two_step} cls={styles.checkbox}/>
            <p className={cn(theme.p12)}>Trust this device</p>
          </div>
          <Button caption={'Create a free account'}
            on_click={()=>{
              if (!is_valid_email(email))
              {
                set_error({fields: ['email'], code: 'invalid_email'});
                return;
              }
              if (!password)
              {
                set_error({fields: ['password'], code: 'empty_password'});
                return;
              }
              if (password.length < 8)
              {
                set_error({fields: ['password'], code: 'short_password'});
                return;
              }
              login_process.set_signup_subscription(props.signup_subscription);
              login_process.create_new_account(email, password, save_two_step,
                props.signup_subscription, props.signup_bonus,
                props.qr_code, props.pro_signup, props.go_to,
                props.get_enc_url);
            }}
            disabled={!!error.code || process_state=='in_progress'}
            cls={cn(styles.signup_button,
              process_state=='in_progress' && styles.hidden_cta)}/>
        </form>
        <p className={cn(theme.p14, theme.med, styles.login_signup_switch)}>
          Already have an account? <a className={styles.underline}
            onClick={e=>{
              e.preventDefault();
              props.go_to(props.can_back ? 'login_buttons'
                : 'login_with_email');
            }}
          href='#'>Log in</a></p>
        <Footer label={'Sign up'}/>
      </div>;
};
